<div class="tabs-bar">
    <ul class="nav nav-tabs">
        <li class="nav-item">
            <a class="nav-link " aria-current="page" routerLink="" [routerLinkActive]="'active'">INFO
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="" [routerLinkActive]="'active'"> DRAWS</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="" [routerLinkActive]="'active'">RESULTS </a>
        </li>

    </ul>
</div>

<section class="body-section" style="padding-top: 30px;">
    <div class="container">


        <main>

            <!-- ======= Product Section ======= -->
            <section class="team Tournaments-list">

                <div class="container aos-init aos-animate" data-aos="fade-up">
                    <div class="row">

                        <div class="col-md-12 find-partner-page Factsheet-body">
                            <div class="col-md-12">
                                <div class="right-side-section col-md-12">


                                    <div class="wrapper max-w-3xl mx-auto px-4">
                                        <div class="item my-3 p-4 border">
                                            <div class="row">
                                                <div class="col-md-12 body-header">
                                                    <div class="media w-100 justify-content-space-between mb-3">
                                                        <!-- <div class="media-left">
                                            <div class="back-button">
                                                <i class='bx bx-left-arrow-alt'></i>
                                                Back
                                            </div>
                                        </div> -->
                                                        <div class="media-body">
                                                            <h4 class="text-left">Davis Cup Qualifiers</h4>

                                                            <div class="sub-headings">
                                                                <i class='bx bx-map'></i> Mumbai |
                                                                Surface: Clay
                                                            </div>
                                                        </div>
                                                        <div class="media-right">
                                                            <div class="enter-button d-flex align-items-center"
                                                                style="gap:10px;">

                                                                <div class="media-right mr-3">
                                                                    <button><span><i
                                                                                class='bx bxs-flag-checkered'></i></span>
                                                                        <span class="big">38</span>
                                                                        registered players
                                                                    </button>
                                                                </div>
                                                                <div class="media-right mr-3">
                                                                    <div class="btn-list">
                                                                        <button (click)="login()" id="edit-login"
                                                                            style="background-color: black; color: #fff!important;"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#login"><span><i
                                                                                    class="bx bx-plus"
                                                                                    style="color: #fff!important;"></i>
                                                                            </span>
                                                                            <span style="font-weight: 400; color: #fff;"
                                                                                class="mobile-d-none "> View
                                                                                players </span>entries
                                                                        </button>





                                                                    </div>

                                                                </div>



                                                            </div>

                                                        </div>

                                                    </div>
                                                    <hr>
                                                </div>
                                                <!-- Button trigger modal -->


                                                <!-- Modal -->



                                                <div class="Tournament-details-bodty">
                                                    <div class=" col-md-8 col-sm-12 p-0">
                                                        <table class="clear condensed secondLeft d-inline-block">
                                                            <!---->

                                                            <tr class="row-club-organizer">
                                                                <th class="px-2 text-right">
                                                                    Organizer
                                                                </th>
                                                                <td class="px-2">

                                                                    <a href="#" class="">
                                                                        IMG Academy
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                            <tr class="mobile-w-100">
                                                                <th class="text-right px-2">
                                                                    Location
                                                                </th>
                                                                <td class="px-2">Leo Tennis
                                                                    Academy<br>no, 39, Manish
                                                                    Nagar Rd, opposite building, Gharkul Society,
                                                                    Indira Nagar, Four Bungalows, Andheri West,
                                                                    Mumbai, Maharashtra 400053, India &nbsp;<a
                                                                        target="_blank"
                                                                        href="https://maps.google.com/?ll=19.1261321,72.8270713"><span
                                                                            class="icon icon-pin-map-fill"></span></a>
                                                                </td>
                                                                <th class="text-right mobile-d-none"></th>
                                                                <td class=" mobile-d-none"></td>
                                                            </tr>
                                                            <tr>
                                                                <th class="text-right px-2">
                                                                    Last Date Of Registration</th>
                                                                <td class="px-2">05/03/2023
                                                                </td>
                                                                <th class="text-right mobile-d-none"></th>
                                                                <td class=" mobile-d-none"></td>
                                                            </tr>
                                                            <tr>
                                                                <th class="text-right px-2"> Tournament Start Date
                                                                </th>
                                                                <td class="px-2">05/03/2023
                                                                </td>
                                                                <th class="text-right mobile-d-none"></th>
                                                                <td class=" mobile-d-none"></td>
                                                            </tr>
                                                            <tr>
                                                                <th class="text-right px-2"> Tournament End Date
                                                                </th>
                                                                <td class="px-2">05/03/2023
                                                                </td>
                                                                <th class="text-right mobile-d-none"></th>
                                                                <td class=" mobile-d-none"></td>
                                                            </tr>
                                                            <tr>
                                                                <th class="text-right px-2"> Last Date Of Withdrawal
                                                                </th>
                                                                <td class="px-2">05/03/2023
                                                                </td>
                                                                <th class="text-right mobile-d-none"></th>
                                                                <td class=" mobile-d-none"></td>
                                                            </tr>

                                                            <tr>
                                                                <th class="text-right px-2"> Organizer Contact
                                                                    Number
                                                                </th>
                                                                <td class="px-2"> <a class="link-main"
                                                                        href="tel:1234567890" target="_blank"
                                                                        rel="noopener noreferrer"><i
                                                                            class='bx bx-phone-call'></i>
                                                                        1234567890</a>
                                                                </td>
                                                                <th class="text-right mobile-d-none"></th>
                                                                <td class=" mobile-d-none"></td>
                                                            </tr>
                                                            <tr>
                                                                <th class="text-right px-2"> Tournament WhatsApp
                                                                    Group Link
                                                                </th>
                                                                <td class="px-2"> <a class="link-main"
                                                                        href=" https://chat.whatsapp.com/"
                                                                        target="_blank" rel="noopener noreferrer"><i
                                                                            class='bx bxl-whatsapp'></i>
                                                                        https://chat.whatsapp.com/</a>

                                                                </td>
                                                                <th class="text-right mobile-d-none"></th>
                                                                <td class=" mobile-d-none"></td>
                                                            </tr>


                                                        </table>
                                                    </div>
                                                    <div class="col-md-4 right-side-logos-div">
                                                        <div class="side-bar-div">
                                                            <div class="tournament-logo ">
                                                                <img src="assets/img/Tournament/logo1.png" alt="">
                                                            </div>

                                                            <div class="col-md-12 admin-details">
                                                                <h4>Academy</h4>
                                                                <div class="media">
                                                                    <div class="media-left">
                                                                        <div class="profile-image">
                                                                            <img src="assets/img/acadmy/ac1.jpg" alt="">
                                                                        </div>
                                                                    </div>
                                                                    <div class="media-body">
                                                                        <h4>IMG Academy</h4>
                                                                        <span> <a href="#" class="flag">
                                                                                <img src="assets/img/players/flag2.png"
                                                                                    alt="">
                                                                            </a> ID: R000110896</span>
                                                                    </div>
                                                                    <div class="media-right">
                                                                        <button style="visibility: hidden;">Contact
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div class="Tournament-details-bottom">
                                                    <h6>Categories</h6>
                                                    <table class="table Categories-table-ui">
                                                        <thead>
                                                            <tr>

                                                                <th scope="col"> Match type</th>
                                                                <th scope="col"> Age group</th>
                                                                <th scope="col"> Entry Fee <em>Per Player</em>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>

                                                                <td>Junior Boy's Singles</td>
                                                                <td>Under 10</td>
                                                                <td>₹ 800</td>
                                                            </tr>
                                                            <tr>

                                                                <td>Junior Boy's Singles</td>
                                                                <td>Under 10</td>
                                                                <td>₹ 800</td>
                                                            </tr>
                                                            <tr>

                                                                <td>Junior Boy's Singles</td>
                                                                <td>Under 10</td>
                                                                <td>₹ 800</td>
                                                            </tr>
                                                            <tr>

                                                                <td>Junior Boy's Singles</td>
                                                                <td>Under 10</td>
                                                                <td>₹ 800</td>
                                                            </tr>
                                                            <tr>

                                                                <td>Junior Boy's Singles</td>
                                                                <td>Under 10</td>
                                                                <td>₹ 800</td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                    <hr>
                                                    <h6>Tournament Rules & Regulations</h6>
                                                    <table class="tounament-rules">
                                                        <tbody>

                                                            <tr>
                                                                <th class="text-right px-2">
                                                                    Factsheet</th>
                                                                <td class="px-2">

                                                                    <div class="Factsheet">
                                                                        <div class="">
                                                                            <p><b>*Tournament Format*</b> </p>

                                                                            <p>One-day Singles Tournament Format is
                                                                                Knock Outs with Back Draw so each
                                                                                participant gets minimum 2 matches.
                                                                            </p>

                                                                            <p>Back Draw means there are two
                                                                                tournaments in parallel. 1st Match
                                                                                Winners will proceed into Main Knock
                                                                                Outs Draw of the U8L Championship.
                                                                                All participants who lose their 1st
                                                                                Match move to Plate Championship for
                                                                                second chance to bounce back and win
                                                                                the Plate Championship.</p>

                                                                            <p>All Rounds till Quarter Finals and
                                                                                Back Draw - Best of 7 games, 4 Games
                                                                                to Win. One Time Deuce then Ad All
                                                                                (Receiver's choice). 7pts Tie-break
                                                                                at 3 games all. Decider Point
                                                                                (Receiver's choice) at 6 all in Tie
                                                                                Break.</p>

                                                                            <p>Quarter Finals, Semi Finals and
                                                                                Finals - Best of 9 games, 5 Games to
                                                                                Win. One Time Deuce then Ad All
                                                                                (Receiver's choice). Standard 7pts
                                                                                Tie-break at 4 games all.</p>
                                                                        </div>
                                                                    </div>

                                                                </td>
                                                                <th class="text-right mobile-d-none"></th>
                                                                <td class="mobile-d-none"></td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="3">

                                                                    <div class="tpl-notes">
                                                                        Please note that the TPL App is not
                                                                        responsible for the tournament's management
                                                                        or draw process. These responsibilities
                                                                        solely rest with the host academy. If you
                                                                        have any concerns, disputes, or queries,
                                                                        kindly contact the host academy directly.
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="Tournament-details-bottom">
                                                    <h6>Sponsors</h6>
                                                </div>
                                                <div class="grid-sponser" id="swiper-wrapper-e39b58782e9310331"
                                                    aria-live="off"
                                                    style="width: 1326px; transform: translate3d(0px, 0px, 0px);">
                                                    <div class="list" role="group" aria-label="1 / 24" style=""><img
                                                            src="assets/img/teams/sponser/1728784-large.png"
                                                            class="img-fluid" alt=""></div>
                                                    <div class="list " role="group" aria-label="2 / 24">
                                                        <img src="assets/img/teams/sponser/494C077B-4458-41C9-8607-7526F7699535.png"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="3 / 24">
                                                        <img src="assets/img/teams/sponser/AITA-01.png"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="4 / 24">
                                                        <img src="assets/img/teams/sponser/BLANCKANVAS-LOGO-ex-01-1-1024x1024.png"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="5 / 24" style=""><img
                                                            src="assets/img/teams/sponser/Courtyard-logo-1024x576.png"
                                                            class="img-fluid" alt=""></div>
                                                    <div class="list" role="group" aria-label="6 / 24">
                                                        <img src="assets/img/teams/sponser/capital-1-01-1024x1024.png"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="7 / 24">
                                                        <img src="assets/img/teams/sponser/Croma-Logo-01-1024x466.png"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="8 / 24">
                                                        <img src="assets/img/teams/sponser/dafanews.jpeg"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="9 / 24" style=""><img
                                                            src="assets/img/teams/sponser/Home-Center-logo.png"
                                                            class="img-fluid" alt=""></div>
                                                    <div class="list" role="group" aria-label="10 / 24">
                                                        <img src="assets/img/teams/sponser/IMG_0964-1024x768.png"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="11 / 24">
                                                        <img src="assets/img/teams/sponser/Kati-Patang-Logo-1-01-1024x1024.png"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="12 / 24">
                                                        <img src="assets/img/teams/sponser/Kotak_Mahindra_Bank_logo-1024x302.png"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="13 / 24" style="">
                                                        <img src="assets/img/teams/sponser/KTTFA-LOGO-01-1024x410.png"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="14 / 24">
                                                        <img src="assets/img/teams/sponser/logo-1.png" class="img-fluid"
                                                            alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="15 / 24">
                                                        <img src="assets/img/teams/sponser/mslta-01.png"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="16 / 24">
                                                        <img src="assets/img/teams/sponser/PHOTO-2021-12-12-12-35-47.jpg"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="17 / 24" style="">
                                                        <img src="assets/img/teams/sponser/Pineal-MAIN-LOGO-copy.png"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="18 / 24">
                                                        <img src="assets/img/teams/sponser/RadioMirchi-logo.png"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="19 / 24">
                                                        <img src="assets/img/teams/sponser/sonyliv-150x150.png"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="20 / 24">
                                                        <img src="assets/img/teams/sponser/Sportnicians-logo-1024x618.png"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="21 / 24" style="">
                                                        <img src="assets/img/teams/sponser/tennis-daily-1024x964.png"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="22 / 24">
                                                        <img src="assets/img/teams/sponser/th-logo-1000x1000-1.png"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="23 / 24">
                                                        <img src="assets/img/teams/sponser/WhatsApp-Image-2021-12-12-at-11.28.28-AM-1024x1024.jpeg"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                    <div class="list" role="group" aria-label="24 / 24">
                                                        <img src="assets/img/teams/sponser/xfast_and_up_logo.png.pagespeed.ic_.ri5QNQPTDm.png"
                                                            class="img-fluid" alt="">
                                                    </div>
                                                </div>

                                            </div>
                                        </div>








                                        <!-- Modal -->

                                    </div>
                                    <div class="pagination flex justify-center my-5"></div>
                                </div>
                            </div>


                        </div>


                    </div>
                </div>
            </section>
            <!-- End Product -->



        </main>
    </div>
</section>


<!--Modal -->
<p-dialog id="login" [(visible)]="visible" [breakpoints]="{ '960px': '75vw' }" [style]="{ width: '38rem' }"
    [modal]="true" [draggable]="false" [resizable]="false">
    <!---test-->

    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
      max-width: 100%;">
        <div class="modal-content" style="border: none;">

            <div class="modal-body">

                <section class="login-page-section">
                    <div class="section-title text-center">
                        <p> To enter Tournament, <br> please login or register.
                        </p>
                    </div>

                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 ">
                                <div class="col-md-12 login-page">
                                    <form method="post" class="login-form">

                                        <p-tabView id="myTabContent">
                                            <p-tabPanel header="Login with OTP">
                                                <div id="OTP" role="tabpanel" aria-labelledby="OTP-tab">
                                                    <div class="name">
                                                        <label for="name_login">Mobile:</label>
                                                        <div class="clear"></div>
                                                        <input id="name_login" name="name_login" type="text"
                                                            placeholder="1234567890" required="">
                                                    </div>
                                                    <div id="login-submit" class="otp-submit">
                                                        <a href="profile.html">

                                                            <input type="submit" value="Send Verification Code">
                                                        </a>
                                                    </div>

                                                </div>
                                            </p-tabPanel>
                                            <p-tabPanel header="Login with Password">
                                                <div class="tab-pane fade show active" id="loginuser" role="tabpanel"
                                                    aria-labelledby="loginuser-tab">
                                                    <div class="name">
                                                        <label for="name_login">Email:</label>
                                                        <div class="clear"></div>

                                                        <input id="name_login" name="name_login" type="email" pInputText
                                                            formControlName="email" placeholder="example@domain.com">
                                                    </div>
                                                    <div class="pwd">
                                                        <label for="password_login">Password:</label>
                                                        <div class="clear"></div>

                                                        <p-password [(ngModel)]="value" [toggleMask]="true"
                                                            id="password_login" placeholder="********"></p-password>
                                                    </div>
                                                    <div class="forgot-p">

                                                        <label for="flexCheckDefault">
                                                            <input class="form-check-input" type="checkbox" value=""
                                                                id="flexCheckDefault">
                                                            <span>Remember me</span>
                                                        </label>
                                                        <label for="forgot-password_login"> <a
                                                                href="forgot-password.html"> Forgot
                                                                Password</a></label>


                                                    </div>
                                                    <a>
                                                        <div id="login-submit" class="Login-button-user"
                                                            data-bs-dismiss="modal">


                                                            <input type="submit" value="Login">


                                                        </div>
                                                    </a>

                                                    <div class="ragister-btn">
                                                        New User? <a href="#">Register Now.</a>
                                                    </div>
                                                </div>
                                            </p-tabPanel>


                                        </p-tabView>



                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        </div>
    </div>

</p-dialog>
<p-dialog id="Entertournament" [(visible)]="TournamentEntry" [breakpoints]="{ '960px': '75vw' }"
    [style]="{ width: '38rem' }" [modal]="true" [draggable]="false" [resizable]="false">
    <!---test-->

    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
      max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Tournament Entry
                </h5>
                <div class="headings col-md-12">
                    <h6>Davis Cup Qualifiers
                    </h6>
                    <p class="note">
                        You can enter a maximum of 1 singles, 1 doubles and 1 mixed doubles tournament
                    </p>
                </div>

            </div>
            <div class="modal-body">
                <div class="add-even col-md-12">
                    <div class="list-tournamnet-add">
                        <div class="event-number">Tournament</div>

                        <div class="col-md-12 list">
                            <h6>Tournament Category</h6>

                            <div class="form">
                                <p-dropdown [options]="test" [(ngModel)]="testCategory" (onChange)="onCategoryChange()"
                                    appendTo="body"></p-dropdown>


                            </div>
                        </div>
                        <div class="col-md-12 list mixed-hide">
                            <h6>Age Category</h6>

                            <div class="form">
                                <p-dropdown [options]="ageCategory" [(ngModel)]="selectedageCategory" optionLabel="name"
                                    appendTo="body"></p-dropdown>

                            </div>
                        </div>


                        <div id="fail" [style.display]="displayFail ? 'block' : 'none'">

                            <h6 style="margin-top: 10px;">Doubles Partner</h6>

                            <div class="form">
                                <div class="input-group mb-3">
                                    <input type="text" class="form-control" placeholder="-"
                                        aria-label="Recipient's username" aria-describedby="basic-addon2" disabled>
                                    <span class="input-group-text" (click)="showaddPartnerDialog()" id="basic-addon2">
                                        <span class="icon"><i class='bx bx-user-plus'></i></span> Add
                                    </span>
                                </div>
                            </div>
                        </div>


                        <!-- <div class="col-md-12 total-price-div">
                            <h4 class="JuniorBoysSingles">Enter Fees : 200 TPL Cash OR 2000 TPL Coin</h4>
                            <h4 class="JuniorBoysDoubles">Enter Fees : 100 TPL Cash OR 1000 TPL Coin</h4>
                            <h4 class="JuniorGirlsSingles">Enter Fees : 2500 TPL Cash OR 25000 TPL Coin</h4>
                        </div> -->

                        <!-- <div class="add-btn col-md-12">
                      <button> Add Another Event <i class='bx bx-plus'></i> </button>
                  </div> -->
                    </div>
                    <div class="list-tournamnet-add hide">
                        <div class="event-number">Tournament</div>

                        <div class="col-md-12 list">
                            <h6>Tournament Category</h6>
                            <div class="form">
                                <select class="form-select" id="result" aria-label="Default select example">
                                    <option selected value="Pass">Select Tournament Category</option>
                                    <option value="Pass">Singles</option>
                                    <option value="Fail">Doubles</option>
                                    <option value="Fail">Mixed Doubles</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-12 list mixed-hide">
                            <h6>Age Category</h6>

                            <div class="form">
                                <select class="form-select" aria-label="Default select example"
                                    id="category-selection-dropdown">
                                    <option value="SelectCategory" selected="">Age Category
                                    </option>
                                    <option value="JuniorBoysSingles">U-10</option>
                                    <option value="JuniorBoysDoubles">U-12
                                    </option>
                                    <option value="JuniorGirlsSingles">U-14
                                    </option>
                                    <option value="JuniorGirlsDoubles">
                                        U-16
                                    </option>
                                    <option value="MensSingles">U-18
                                    </option>
                                    <option value="WomensSingles">Men’s
                                    </option>
                                    <option value="WomensDoubles">Women’s
                                    </option>

                                </select>
                            </div>
                        </div>


                        <div id="fail" class="col-md-12 list" style="display:none">
                            <h6>Age Category</h6>

                            <div class="form">
                                <select class="form-select" aria-label="Default select example"
                                    id="category-selection-dropdown">
                                    <option value="SelectCategory" selected="">Age Category
                                    </option>
                                    <option value="JuniorBoysSingles">U-10</option>
                                    <option value="JuniorBoysDoubles">U-12
                                    </option>
                                    <option value="JuniorGirlsSingles">U-14
                                    </option>
                                    <option value="JuniorGirlsDoubles">
                                        U-16
                                    </option>
                                    <option value="MensSingles">U-18
                                    </option>
                                    <option value="WomensSingles">Men’s
                                    </option>
                                    <option value="WomensDoubles">Women’s
                                    </option>
                                    <option value="WomensDoubles">Mixed
                                    </option>

                                </select>
                            </div>
                            <h6 style="margin-top: 10px;">Doubles Partner</h6>

                            <div class="form">
                                <div class="input-group mb-3">
                                    <input type="text" class="form-control" placeholder="-"
                                        aria-label="Recipient's username" aria-describedby="basic-addon2" disabled>
                                    <span class="input-group-text" id="basic-addon2"> <span class="icon"><i
                                                class='bx bx-user-plus'></i></span> Add
                                    </span>
                                </div>
                            </div>
                        </div>


                        <!-- <div class="col-md-12 total-price-div">
                            <h4 class="JuniorBoysSingles">Enter Fees : 200 TPL Cash OR 2000 TPL Coin</h4>
                            <h4 class="JuniorBoysDoubles">Enter Fees : 100 TPL Cash OR 1000 TPL Coin</h4>
                            <h4 class="JuniorGirlsSingles">Enter Fees : 2500 TPL Cash OR 25000 TPL Coin</h4>
                        </div> -->

                        <!-- <div class="add-btn col-md-12">
                      <button> Add Another Event <i class='bx bx-plus'></i> </button>
                  </div> -->
                    </div>

                    <div class="add-more-btn">
                        <button id="add-another-div"> Add Another Event <i class='bx bx-plus'></i> </button>
                    </div>

                </div>
            </div>
            <div class="modal-footer">

                <button type="button" class="btn btn-primary mx-auto" (click)="walletPay()">Confirm</button>
            </div>
        </div>
    </div>

</p-dialog>
<p-dialog id="Entertournamentpartner" [(visible)]="addPartner" [breakpoints]="{ '960px': '75vw' }"
    [style]="{ width: '38rem' }" [modal]="true" [draggable]="false" [resizable]="false">
    <!---test-->

    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
      max-width: 100%;">

        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Tournament Entry
                </h5>
                <div class="headings col-md-12">
                    <h6>Davis Cup Qualifiers
                    </h6>
                    <p class="note">
                        You can find a new doubles partner by entering either their TPL ID or Email address.




                    </p>
                </div>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="add-even col-md-12">
                    <!-- <div class="event-number">Add Partner</div> -->

                    <div class="col-md-12 list">
                        <h6>TPL ID
                        </h6>
                        <div class="mb-3">

                            <input type="text" class="form-control" id="exampleFormControlInput1"
                                placeholder="Enter TPL ID">
                        </div>

                    </div>
                    <p class="divider"> <span>OR</span></p>
                    <div class="col-md-12 list">
                        <h6>Enter Email Address of Player that is registered with the TPL

                        </h6>
                        <div class="mb-3">

                            <input type="Emai" class="form-control" id="exampleFormControlInput1"
                                placeholder="Enter Partner Email">
                        </div>

                    </div>

                    <!-- <div class="add-btn col-md-12">
                <button> Add Another Event <i class='bx bx-plus'></i> </button>
            </div> -->

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary mx-auto " (click)="addedPartner()">Add Partner</button>
            </div>
        </div>

    </div>

</p-dialog>
<p-dialog id="Pay" [(visible)]="Walletdialog" [breakpoints]="{ '960px': '75vw' }" [style]="{ width: '35.5rem' }"
    [modal]="true" [draggable]="false" [resizable]="false">
    <!---test-->

    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
      max-width: 100%;">

        <div class="modal-content">
            <div class="modal-header card-title">
                <h1 class="modal-title fs-5" id="PayLabel">Balance</h1>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body pay">
                <div class="card-body">
                    <div class="payment-info flex justify-space-between">
                        <div class="column shipping w-100">
                            <form action="#">
                                <div class="container-fluid grid">
                                    <div class="row pull-center">
                                        <div class="col-md-12 pp-none-mobile">
                                            <div class="wallet-screen" style="display: block;">
                                                <div class="total-amount">
                                                    <div class="wallet-icons">
                                                        <div class="icon">
                                                            <i class='bx bx-wallet-alt'></i>
                                                        </div>
                                                        <h1>Entry Fees</h1>
                                                        <h1> 250 TPL Cash </h1>
                                                        <div class="table-selectform w-100">
                                                            <table class="table table-bordered">
                                                                <thead>
                                                                    <tr>

                                                                        <th scope="col">Tournament Name</th>
                                                                        <th scope="col">Categories</th>

                                                                        <th scope="col">Entry Fees</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>

                                                                        <td>Davis Cup Qualifiers </td>
                                                                        <td>Junior Boy's Singles
                                                                        </td>

                                                                        <td>Rs 2500</td>
                                                                    </tr>


                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 add-buttons">
                                                        <div class="heading d-flex justify-content-between">
                                                            <h2>Select Payment</h2>
                                                            <h2> <span class="mobile-none-d">Available</span>
                                                                Balance</h2>
                                                            <div class="btn"></div>
                                                        </div>


                                                        <ul>
                                                            <li class="tpl-cash"> <label class="form-check-label"
                                                                    for="flexRadioDefault1">
                                                                    <input class="form-check-input" type="radio"
                                                                        name="flexRadioDefault" id="flexRadioDefault1"
                                                                        (click)="onRadioClick()">
                                                                    <!-- <input class="form-check-input" type="radio"
                                          name="flexRadioDefault"
                                          id="flexRadioDefault1"> -->
                                                                    <div class="buttons">
                                                                        TPL Cash <span class="Balance">
                                                                            100 <span class="addmore"
                                                                                (click)="Addcashdialog()">
                                                                                Add Cash </span></span>

                                                                    </div>
                                                                </label>


                                                            </li>

                                                            <!-- <li class="tpl-coins">
                                  <label class="form-check-label"
                                      for="flexRadioDefault2">
                                      <input class="form-check-input" type="radio"
                                          name="flexRadioDefault"
                                          id="flexRadioDefault2">
                                      <div class="buttons">
                                          TPL Coins <span class="Balance">
                                              1000 <span class="addmore"
                                                  data-bs-target="#add-coin"
                                                  data-bs-toggle="modal"
                                                  data-bs-dismiss="modal">
                                                  Add Coins </span></span>

                                      </div>
                                  </label>
                              </li> -->

                                                        </ul>
                                                        <p class="cash-ms"
                                                            [style.display]="displayCashMs ? 'block' : 'none'">
                                                            After Transaction Your Balance will Be 50 Cash
                                                        </p>
                                                        <p class="coin-ms" style="display: none
                          ;">After Transaction Your Balance
                                                            Will Be 500 Coins
                                                        </p>
                                                        <div class="col-md-12 text-center">
                                                            <a id="Entered-btn" class="button button-primary"
                                                                (click)="thankyouModal()">
                                                                Register
                                                            </a>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</p-dialog>

<p-dialog id="add-cash" [(visible)]="Addcashmodal" [breakpoints]="{ '960px': '75vw' }" [style]="{ width: '38rem' }"
    [modal]="true" [draggable]="false" [resizable]="false">
    <!---test-->

    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
  max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header card-title">
                <h1 class="modal-title fs-5" id="add-cashLabel">Add Cash</h1>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body add-cash pay">
                <div class="card-body">

                    <div class="payment-info flex justify-space-between">
                        <div class="column shipping w-100">
                            <form action="#">
                                <div class="container-fluid grid">
                                    <div class="row pull-center">
                                        <div class="col-md-12 ">

                                            <div class="wallet-screen" style="display: block;">
                                                <div class="total-amount">
                                                    <div class="wallet-icons">
                                                        <div class="icon">
                                                            <i class='bx bx-wallet-alt'></i>
                                                        </div>
                                                        <h1>Enter Amount</h1>
                                                    </div>
                                                    <div class="col-md-12 add-buttons">



                                                        <div class="add-money-form col-md-12">
                                                            <input type="number" id="myInput2" placeholder="₹ 0.00"
                                                                (input)="myFunction2()">

                                                        </div>
                                                        <div id="text-out">{{outputText}}</div>

                                                        <div class="col-md-12 text-center">
                                                            <a href="#" class="button button-primary"
                                                                data-bs-target="#thankyou" data-bs-toggle="modal"
                                                                data-bs-dismiss="modal">
                                                                Add to Wallet
                                                            </a>
                                                        </div>

                                                    </div>
                                                </div>

                                                <!-- <div class="col-md-12 ADD-cash">
                                              <label for="">
                                                  <div class="icon">
                                                      <i class='bx bx-money'></i>
                                                  </div>
                                                  <input type="text" name="" id=""
                                                      placeholder="Enter Amount" value="₹1000"
                                                      class="form-control">
                                                  <div class="total-amt">
                                                      <button>Add <span>
                                                              <i class='bx bx-plus'></i>
                                                          </span>
                                                      </button>
                                                  </div>
                                              </label>

                                          </div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </div>


    </div>

</p-dialog>
<p-dialog id="Entertournamentthank" [(visible)]="thanYoumodal" [breakpoints]="{ '960px': '75vw' }"
    [style]="{ width: '38rem' }" [modal]="true" [draggable]="false" [resizable]="false">
    <!---test-->

    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
  max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Tournament Entry
                </h5>
                <div class="headings col-md-12">
                    <h6>Davis Cup Qualifiers
                    </h6>
                    <p class="note">
                        You have successfully registered




                    </p>
                </div>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

        </div>


    </div>

</p-dialog>
<p-dialog id="Entertournamentview" [(visible)]="WithdrawModal" [breakpoints]="{ '960px': '75vw' }"
    [style]="{ width: '38rem' }" [modal]="true" [draggable]="false" [resizable]="false">
    <!---test-->

    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
  max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Tournament Entry
                </h5>
                <div class="headings col-md-12">
                    <h6>Davis Cup Qualifiers
                    </h6>
                    <p class="note">
                        You can find a new doubles partner by entering either their TPL ID or Email address.




                    </p>
                </div>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" data-bs-toggle="modal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="add-even col-md-12">
                    <!-- <div class="event-number">Add Partner</div> -->

                    <div class="event-details-list">
                        <div class="list-div-selection">
                            <div class="event-details">
                                <div class="title">Tournament-01</div>

                                <div class="Event-cate">
                                    <ul>
                                        <li>
                                            <span class="small-heading">Tournament</span>
                                            <p>Junior Boy's Single
                                            </p>
                                        </li>
                                        <!-- <li>
                                    <span class="small-heading">Partner
                                    </span>
                                    <p>None selected
                                    </p>
                                </li> -->

                                    </ul>
                                    <!-- <div class="edite">
                            <button> <span><i class='bx bx-edit-alt'></i></span> Edit</button>
                        </div> -->

                                </div>
                                <div class="checkbox-icon" [class.active]="isActive" (click)="toggleActive()">
                                    <i class='bx bx-radio-circle'></i>
                                    <i class='bx bx-radio-circle-marked'></i>
                                    <span>Withdraw</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="event-details-list">
                        <div class="list-div-selection">
                            <div class="event-details">
                                <div class="title">Tournament-02</div>

                                <div class="Event-cate">
                                    <ul>
                                        <li>
                                            <span class="small-heading">Tournament</span>
                                            <p>Mixed Doubles
                                            </p>
                                        </li>
                                        <li>
                                            <span class="small-heading">Partner
                                            </span>
                                            <p style="cursor: pointer;" data-bs-target="#Entertournamentpartner"
                                                data-bs-toggle="modal">None
                                                selected
                                            </p>
                                        </li>

                                    </ul>
                                    <!-- <div class="edite">
                            <button> <span><i class='bx bx-edit-alt'></i></span> Edit</button>
                        </div> -->

                                </div>
                                <div class="checkbox-icon " [class.active]="isActive2" (click)="toggleActive2()">
                                    <i class='bx bx-radio-circle'></i>
                                    <i class='bx bx-radio-circle-marked'></i>

                                    <span>Withdraw</span>
                                </div>
                            </div>

                        </div>
                    </div>


                    <!-- <div class="add-btn col-md-12">
        <button> Add Another Event <i class='bx bx-plus'></i> </button>
    </div> -->

                </div>
            </div>
            <div class="modal-footer">

                <button type="button" class="btn btn-primary mx-auto " (click)="Withdrawconfirmmodal()">Confirm</button>
            </div>
        </div>


    </div>

</p-dialog>
<p-dialog id="widthdraw-confitmation" [(visible)]="WithdrawcnfModal" [breakpoints]="{ '960px': '75vw' }"
    [style]="{ width: '38rem' }" [modal]="true" [draggable]="false" [resizable]="false">
    <!---test-->

    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
  max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Withdraw Confirmation
                </h5>

                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" data-bs-toggle="modal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

                <p>
                    Are you sure you want to withdraw from the tournament? Please note that this action cannot be
                    undone, and your participation in the tournament will be canceled.
                </p>


                <div class="add-even col-md-12">
                    <!-- <div class="event-number">Add Partner</div> -->

                    <div class="event-details-list">
                        <div class="list-div-selection">
                            <div class="event-details">
                                <div class="title">Tournament-01</div>

                                <div class="Event-cate">
                                    <ul>
                                        <li>
                                            <span class="small-heading">Tournament</span>
                                            <p>Mixed Doubles
                                            </p>
                                        </li>
                                        <li>
                                            <span class="small-heading">Partner
                                            </span>
                                            <p>None
                                                selected
                                            </p>
                                        </li>

                                    </ul>
                                    <!-- <div class="edite">
                    <button> <span><i class='bx bx-edit-alt'></i></span> Edit</button>
                </div> -->

                                </div>

                            </div>

                        </div>
                    </div>
                    <p>
                        After the withdrawal, the entry fee amount will be credited back to your TPL wallet. in cash
                        within 4
                        days.
                    </p>


                    <!-- <div class="add-btn col-md-12">
<button> Add Another Event <i class='bx bx-plus'></i> </button>
</div> -->

                </div>
            </div>
            <div class="modal-footer">

                <button type="button" class="btn btn-primary mx-auto " (click)="thankyouwithdraw()">Proceed with the
                    withdrawal</button>
            </div>
        </div>


    </div>

</p-dialog>
<p-dialog id="Entertournamentthank" [(visible)]="thankwithdraw" [breakpoints]="{ '960px': '75vw' }"
    [style]="{ width: '38rem' }" [modal]="true" [draggable]="false" [resizable]="false">
    <!---test-->

    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
  max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Tournament Entry
                </h5>
                <div class="headings col-md-12">
                    <h6>Davis Cup Qualifiers
                    </h6>
                    <p class="note">
                        Your Tournament withdrawals have been successfully processed. progressed
                    </p>
                </div>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

        </div>


    </div>

</p-dialog>



<p-dialog [closable]="true" [(visible)]="loginRegisterModal" [modal]="true" [style]="{width: '38vw'}"
    [breakpoints]="{'960px': '60vw', '768px': 'calc(100% - 30px)'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    TO ENTER CONTEST,
    PLEASE LOGIN OR REGISTER.
    <p-tabView>
        <p-tabPanel header="Login With Password">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 ">
                        <div class="col-md-12 login-page">
                            <form class="login-form" [formGroup]="loginForm" *ngIf="this.loginForm"
                                (ngSubmit)="onSubmit()">
                                <div class="name">
                                    <label for="name_login">Email:</label>
                                    <div class="clear"></div>
                                    <input type="email" id="name_login" formControlName="email"
                                        placeholder="Email Address*"
                                        [ngClass]="{ 'is-invalid': loginFormSubmitted && loginf.email.errors }"
                                        required>
                                    <div *ngIf="loginFormSubmitted && loginf.email.errors" class="invalid-feedback">
                                        <div *ngIf="loginf.email.errors.required">Email is required</div>
                                        <div *ngIf="loginf.email.errors.email">Enter valid email address
                                        </div>
                                    </div>
                                </div>
                                <div class="pwd">
                                    <label for="password_login">Password:</label>
                                    <div class="clear"></div>
                                    <p-password [toggleMask]="true" id="password_login" formControlName="password"
                                        placeholder="Password*" class="form-control"
                                        [ngClass]="{ 'is-invalid': loginFormSubmitted && loginf.password.errors }"
                                        autocomplete="on" required></p-password>
                                    <div *ngIf="loginFormSubmitted && loginf.password.errors" class="invalid-feedback">
                                        <div *ngIf="loginf.password.errors.required">Password is required
                                        </div>
                                        <div *ngIf="loginf.password.errors.minlength">Password must be at
                                            least 6
                                            characters
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 input-form">
                                </div>
                                <div class="col-md-12 input-form">
                                    <div *ngIf="isLoginFailed" class="alert alert-danger" role="alert">
                                        {{errorMessage}}
                                    </div>
                                </div>
                                <div class="forgot-p">
                                    <label for="flexCheckDefault">
                                        <div class="forms">
                                            <input class="form-check-input" type="checkbox" value=""
                                                id="flexCheckDefault">
                                            <span>Remember me</span>
                                        </div>
                                    </label>
                                    <label for="forgot-password_login"> <a (click)="onClickForgotPassword()">
                                            Forgot
                                            Password</a></label>
                                </div>
                                <div id="login-submit" class="otp-submit">
                                    <input pButton type="submit" value="Login">
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Login With OTP">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 ">
                        <div *ngIf="!showMobileLoginOtpForm" class="col-md-12 login-page">
                            <form class="login-form" [formGroup]="mobileLoginForm" *ngIf="this.mobileLoginForm"
                                (ngSubmit)="onMobilePhoneSubmit()">
                                <div class="Phone">
                                    <label for="name_login">* Phone Number:</label>
                                    <div class="clear"></div>
                                    <p-inputNumber mode="decimal" [useGrouping]="false" formControlName="mobileNumber"
                                        [ngClass]="{ 'is-invalid': submitted && mobNumberFormValidation.mobileNumber.errors }"
                                        required placeholder="Enter your mobile number">
                                    </p-inputNumber>
                                    <div *ngIf="submitted && mobNumberFormValidation.mobileNumber.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="mobNumberFormValidation.mobileNumber.errors.required">
                                            Mobile number is required
                                        </div>
                                        <div *ngIf="mobNumberFormValidation.mobileNumber.errors">
                                            Invalid Mobile Number
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="showMobileFormErrors">
                                    {{mobileFormsErrors}}
                                </div>
                                <div id="login-submit">
                                    <input type="submit" value="Submit">
                                </div>
                            </form>
                        </div>
                        <div *ngIf="showMobileLoginOtpForm" class="col-md-12 Otp login-page">
                            <div class="container height-100 d-flex justify-content-center align-items-center">
                                <div class="position-relative">
                                    <div class="card p-2 text-center">
                                        <div class="col-md-12 otp-header">
                                            <div class="row">
                                                <div class="col-2">
                                                    <div class="back-btn">
                                                        <i class="bi bi-chevron-left"></i>
                                                    </div>
                                                </div>
                                                <div class="col-10">
                                                    <h2>Mobile Verification</h2>
                                                </div>
                                            </div>
                                        </div>
                                        <h6>Please enter the one time password <br> to verify your account
                                        </h6>
                                        <div> <span>A code has been sent to </span>
                                            <small>{{mobileNumber}}</small>
                                        </div>
                                        <div id="otp" class="inputs d-flex flex-row justify-content-center mt-2">
                                            <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)"
                                                [config]="config" [formCtrl]="YourFormControl">
                                            </ng-otp-input>
                                            <div *ngIf="showOtpErrors">
                                                <span>Please enter OTP.</span>
                                            </div>
                                            <div *ngIf="showOtpLoginErrors">
                                                <span>{{otpLoginErrors}}</span>
                                            </div>
                                        </div>
                                        <div>
                                            <span *ngIf="!showResendButton">{{displayTime}}</span>
                                            <span *ngIf="showResendButton">
                                                <div id="">
                                                    <a (click)="resendOtp()">Resend</a>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="login-submit">
                                <input type="submit" (click)="onClickOtpLoginSubmit()" value="Submit">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </p-tabPanel>
    </p-tabView>
</p-dialog>
<p-dialog [closable]="true" [(visible)]="showForgotPasswordForm" [modal]="true" [style]="{width: '38vw'}"
    [breakpoints]="{'960px': '60vw', '768px': 'calc(100% - 30px)'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <section *ngIf="showForgotPasswordForm" class="login-page-section">
        <div class="section-title text-center">
            <p> Forgot Password
            </p>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-12 ">
                    <div class="col-md-12 login-page">
                        <form [formGroup]="forgotPassForm">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="style-form-group">
                                        <input type="email" formControlName="email" class="form-control form-input"
                                            placeholder="Your Email *"
                                            [ngClass]="{ 'is-invalid': submitted && forgotPassValidation.email.errors }">
                                        <div *ngIf="submitted && forgotPassValidation.email.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="forgotPassValidation.email.errors.required">Email is
                                                required</div>
                                            <div *ngIf="forgotPassValidation.email.errors.pattern">Email must be a
                                                valid
                                                email address</div>
                                        </div>
                                        <div *ngIf="successMessage" style="color:green;">{{successMessage.message}}
                                        </div>
                                        <div *ngIf="errorMessage" style="color:red;">{{errorMessage}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="button pt-2 pt-lg-3">
                                <button class="forgot-pass-submit"
                                    (click)="onForgotPassSubmit()">Submit</button>&nbsp;&nbsp;
                                <button class="forgot-pass-back" (click)="onForgotPassBack()">Back</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</p-dialog>